import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { IEmployeeSFilter } from 'src/@types/SearchFilterTypes';
import { RHFSelect, RHFTextField } from 'src/components/hook-form';
import FormProvider from 'src/components/hook-form/FormProvider';
import { FormItem, SearchFormLayout } from 'src/layouts/form/FormLayout';
import { useStores } from 'src/models';
import removeNullUndefined from 'src/utils/removeNullUndefined';

export interface ISearchFormProps {
  onSearch: (data: IEmployeeSFilter) => void;
}

export const SearchForm = observer(({ onSearch }: ISearchFormProps) => {
  const { t } = useTranslation();
  const methods = useForm<Partial<IEmployeeSFilter>>({
    defaultValues: { oprtrSttsCd: '', loginId: '', oprtrNm: '' },
  });

  // 계정 상태
  const { commonCodeStore } = useStores();
  const OPRTR_STTS_CD = commonCodeStore.getCCodeByName('OPRTR_STTS_CD');

  // 검색 함수
  const onValid = (data: Partial<IEmployeeSFilter>) => {
    const cleanedData = removeNullUndefined(data);
    onSearch(cleanedData);
  };

  return (
    <FormProvider methods={methods} onSubmit={methods.handleSubmit(onValid)}>
      <SearchFormLayout method={methods} open={true} cols={3}>
        <FormItem>
          <RHFSelect
            label={t('employee.fields.oprtrSttsCd.name')}
            name="oprtrSttsCd"
            options={OPRTR_STTS_CD || []}
          />
        </FormItem>
        <FormItem>
          <RHFTextField label={t('employee.fields.loginId.name')} name="loginId" />
        </FormItem>
        <FormItem>
          <RHFTextField label={t('employee.fields.oprtrNm.name')} name="oprtrNm" />
        </FormItem>
      </SearchFormLayout>
    </FormProvider>
  );
});

export default SearchForm;
